__turbopack_context__.v({
  "tab": "filter-button-module__tss5nq__tab",
  "tab-active": "filter-button-module__tss5nq__tab-active",
});
